import { render, staticRenderFns } from "./RedEnvelopeRecord.vue?vue&type=template&id=2faef56d&scoped=true&"
import script from "./RedEnvelopeRecord.vue?vue&type=script&lang=js&"
export * from "./RedEnvelopeRecord.vue?vue&type=script&lang=js&"
import style0 from "./RedEnvelopeRecord.vue?vue&type=style&index=0&id=2faef56d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faef56d",
  null
  
)

export default component.exports